import { render, staticRenderFns } from "./SalonOrderConfirm.vue?vue&type=template&id=d2a34ad0&scoped=true&"
import script from "./SalonOrderConfirm.vue?vue&type=script&lang=js&"
export * from "./SalonOrderConfirm.vue?vue&type=script&lang=js&"
import style0 from "./SalonOrderConfirm.vue?vue&type=style&index=0&id=d2a34ad0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2a34ad0",
  null
  
)

export default component.exports